export default "__VITE_ASSET__DA1GuJB4__"